export default function DataForm(props){
  const page = props.page || "Study Information";  // this needs to be changed to pull from DocumentDataProvider
  return(
    <div>
      {page} (for documents or projects) coming soon!
    </div>
  );
}